<template>
  <b-modal
    id="textNoteModal"
    ref="textNoteModal"
    size="md"
    hide-header
    hide-footer
    no-stacking
    lazy
    modal-class="text-note-window"
    v-if="movement"
  >
    <a class="close" @click.stop.prevent="hide()">
      <i class="icon-notice_close"></i>
    </a>
    <div class="col-md-12 movement-notice">
      <div class="fixed">
        <div class="notice-content">
          <TextNote :textNote="textNote" :artwork="movement" :isSingleArtwork="true" v-if="textNote" />
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { partialStrings } from 'config';
import FilterBuilder from 'lib/filterBuilder';

import TextNote from './TextNote.vue';

export default {
  name: 'MovementTextNoteModal',
  components: {
    TextNote,
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'textNoteModal') {
        const query = Object.assign({}, this.$route.query, { note: null });
        const filters = FilterBuilder.toURLParam(this.locationFilters);

        this.$router
          .push({ name: 'Movements', query, ...(this.locationFilters.length && { params: { filters } }) })
          .catch(() => {});
      }
    });
  },
  methods: {
    hide() {
      this.$refs.textNoteModal.hide();
    },
  },
  computed: {
    ...mapState('artworks', {
      movement: 'artwork',
    }),
    ...mapState('textNotes', ['textNote']),
    ...mapGetters('params', ['locationFilters']),
  },
  watch: {
    textNote(to, from) {
      if (to && from !== to) {
        this.$refs.textNoteModal.show();
      } else {
        this.$refs.textNoteModal.hide();
      }
    },
  },
  data() {
    return {
      scrollOptions: {
        suppressScrollX: true,
        wheelPropagation: true,
      },
      partials: partialStrings,
    };
  },
};
</script>
